import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Tile.css';

export class Tile extends Component {
    static propTypes = {
        name: PropTypes.string,
        description: PropTypes.string,
        source_url: PropTypes.string,
        documentation_url: PropTypes.string
    }

    render() {
        return (
            <div className="info-tile">
                <div className="info-tile-content">
                    <div className="tile">
                        <div className="center-content">
                            <div className="tile-image tile-2"></div>
                            <div className="info-tile-title-bar">
                                <div className="cat-title-container">
                                    <h1 className="content-title">{this.props.name}</h1>
                                </div>
                            </div>
                            <p>
                                {this.props.description}
                            </p>
                            <div className="effort-links">
                                <a href={this.props.source_url} target="_blank" rel="noopener noreferrer"><i className="link-icon github"></i>Get the Code</a>
                                {this.getDocsLink()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    getDocsLink() {
        if (this.props.documentation_url) {
            return (
                <a 
                    href={this.props.documentation_url} 
                    onClick={(event) => this.onLinkClick(event)}>
                        <i className="link-icon go-to"></i>
                    Read More
                </a>
            )
        }
    }
    onLinkClick(event) {
        event.preventDefault();
        window.location.href = this.props.documentation_url;
    }
}


// WEBPACK FOOTER //
// ./src/components/Tile.js